import { render, staticRenderFns } from "./deleted.vue?vue&type=template&id=37d05078&scoped=true"
import script from "./deleted.vue?vue&type=script&lang=js"
export * from "./deleted.vue?vue&type=script&lang=js"
import style0 from "./deleted.vue?vue&type=style&index=0&id=37d05078&prod&scoped=true&lang=scss"
import style1 from "./deleted.vue?vue&type=style&index=1&id=37d05078&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d05078",
  null
  
)

export default component.exports